module.exports = __webpack_public_path__ + "static/media/rename.3e28cbb0.svg";